import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnInit,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CompanyService } from '../../../../_services';
import {
    TrainerMutationInput,
    TrainerQueryOutput,
} from '../models/trainer.model';

@Component({
    selector: 'trainer-detail-description',
    templateUrl: './description.component.html',
    styleUrls: [
        '../../trainer.component.scss',
        '../detail.component.scss',
        './description.style.scss',
    ],
    providers: [TranslatePipe],
})
export class TrainerDetailDescriptionComponent implements OnInit, OnChanges {
    @Input() trainer: TrainerQueryOutput;
    currentTrainer: TrainerQueryOutput;
    error: string;
    @Input() availableLanguages: string[] = [];
    @Output() onTrainerSaved = new EventEmitter();
    time = '';
    currentTrainerLanguages: { [key: string]: boolean } = {};
    languages = [];

    constructor(private companyService: CompanyService) {}

    ngOnInit() {
        this.currentTrainer = this.trainer;
    }

    ngOnChanges({ availableLanguages, trainer }: SimpleChanges) {
        const trainerLanguageCodes = trainer.currentValue.trainerLanguages.map(
            (language) => language.code
        );
        availableLanguages.currentValue
            .map((language) => [
                language.code,
                trainerLanguageCodes.includes(language.code),
            ])
            .forEach(([language, trainerCanTrain]) => {
                this.currentTrainerLanguages[language] = trainerCanTrain;
            });
    }

    companySelected() {
        return Boolean(this.currentTrainer.company.name);
    }

    searchCompanies(keyword: string) {
        return this.companyService.search(keyword);
    }

    myListFormatter(data: any): string {
        let html = '';
        html += data.name ? `<span><strong>${data.name}</strong></span>` : '';
        html += data.id ? `<span> (${data.id})</span>` : '';
        html += data.city ? `<span> - ${data.city}</span>` : '';
        return html;
    }

    changeCompany(newVal) {
        if (
            newVal !== null &&
            typeof newVal !== 'undefined' &&
            newVal.id !== null &&
            typeof newVal.id !== 'undefined'
        ) {
            this.currentTrainer.companyId = newVal.id;
            this.currentTrainer.company.name = newVal.name;
        }
    }

    validate(event) {
        event.preventDefault();
        let trainer: TrainerMutationInput = {
            id: this.currentTrainer.id,
            active: this.currentTrainer.active,
            bio: this.currentTrainer.bio,
            city: this.currentTrainer.city,
            email: this.currentTrainer.email,
            company_id: this.currentTrainer.companyId,
            first_name: this.currentTrainer.firstName,
            interne: this.currentTrainer.interne,
            country_code: this.currentTrainer.countryCode,
            address1: this.currentTrainer.address1,
            job: this.currentTrainer.job,
            last_name: this.currentTrainer.lastName,
            title: this.currentTrainer.title,
            zip_code: this.currentTrainer.zipCode,
            trainer_languages: {
                data: Object.entries(this.currentTrainerLanguages)
                    .filter(([_, state]) => state === true)
                    .map(([language_code, _]) => ({ language_code })),
            },
        };
        this.onTrainerSaved.emit(trainer);
    }

    focusOnCompanyAutocomplete() {
        this.currentTrainer.company.name = '';
        this.currentTrainer.companyId = null;
    }

    getBoolTranslateKey(data: any): string {
        if (data) {
            return 'global.true';
        }
        return 'global.false';
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/detail/description/description.component.ts